import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import AutoLinker from "autolinker";
import {
  localizedField,
  t,
  useLanguage,
} from "../../../contexts/LanguageContext";

export default function AlertDialog(props) {
  const { language } = useLanguage();

  return (
    <Dialog
      id="alert-dialog-box"
      open={props.open}
      onClose={props.onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        {localizedField(props.marker, "name", language)}
      </DialogTitle>
      <DialogContent id="alert-dialog-description-box">
        <DialogContentText id="alert-dialog-description" component="div">
          <div
            dangerouslySetInnerHTML={{
              __html: localizedField(props.marker, "description", language),
            }}
          />

          {props.marker.properties.map((property, index) => {
            const key = localizedField(property, "key", language);
            const value = localizedField(property, "value", language);
            const valueText = AutoLinker.link(value, {
              phone: false, // ← 電話番号をリンクにしない
            });
            return (
              <div key={index}>
                <h5>{key}</h5>
                <div dangerouslySetInnerHTML={{ __html: valueText }} />
              </div>
            );
          })}
        </DialogContentText>
      </DialogContent>
      <DialogActions id="alert-dialog-button-box">
        <Button
          onClick={props.onClose}
          color="primary"
          id="alert-dialog-button"
          autoFocus
        >
          {t("close", language)}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
